import styled from 'styled-components';

export const NotificationBreadcrumb = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	color: #6B7280;
	padding: 16px 0px;
`;

export const BreadcrumbItem = styled.span<{ active?: boolean }>`
	color: ${props => props.active ? '#9CA3AF' : '#374151'};
	cursor: ${props => props.active ? 'default' : 'pointer'};
	
	&:hover {
		color: ${props => props.active ? '#9CA3AF' : '#1F2937'};
	}
`;

export const BreadcrumbSeparator = styled.img`
	width: 12px;
	height: 12px;
	margin: 0 4px;
`;

export const NotificationContainer = styled.div`
	background-color: #F3F4F6;
	padding: 24px 0px 40px;
	border-radius: 12px;
	max-width: 1200px;
	margin: 0 auto;
`;

export const NotificationHeader = styled.div`
	margin-bottom: 24px;
`;

export const NotificationTitle = styled.h1`
	font-size: 24px;
	font-weight: 700;
	color: #111827;
	margin: 0 0 8px 0;
`;

export const NotificationSubtitle = styled.p`
	font-size: 16px;
	color: #6B7280;
	margin: 0;
`;

export const NotificationSummaryCards = styled.div`
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 16px;
	margin-bottom: 24px;
`;

export const NotificationCard = styled.div`
	background-color: #FFFFFF;
	border-radius: 12px;
	padding: 20px;
	display: flex;
	align-items: center;
	gap: 16px;
	transition: all 0.2s ease;
	
	&:hover {
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
		transform: translateY(-1px);
		cursor: pointer;
	}
`;

export const NotificationCardIcon = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const NotificationCardContent = styled.div`
	flex: 1;
`;

export const NotificationCardTitle = styled.div`
	font-size: 14px;
	color: #6B7280;
	margin-bottom: 4px;
`;

export const NotificationCardValue = styled.div`
	font-size: 24px;
	font-weight: 700;
`;

export const NotificationFilterSection = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 24px;
`;

export const NotificationFilterButtons = styled.div`
	display: flex;
	gap: 8px;
`;

export const NotificationFilterButton = styled.button<{ active?: boolean }>`
    padding: 10px 16px;
    border-radius: 4px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	border: none;
	background-color: ${props => props.active ? '#2563EB' : '#FFFFFF'};
	color: ${props => props.active ? '#FFFFFF' : '#111827'};
	
	&:hover {
		background-color: ${props => props.active ? '#2563EB' : '#2563EB'};
		color: ${props => props.active ? '#FFFFFF' : '#FFFFFF'};
	}
`;

export const NotificationActionButton = styled.button`
	background-color: #17B26A;
	color: #FFFFFF;
	border: none;
	padding: 8px 16px;
	border-radius: 6px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	display: flex;
	align-items: center;
	
	&:hover {
		background-color: #059669;
	}
`;

export const NotificationList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	margin-bottom: 24px;
`;

export const NotificationItem = styled.div`
	background-color: #FFFFFF;
	border-radius: 12px;
	padding: 20px;
	display: flex;
	gap: 16px;
	border: 1px solid #E5E7EB;
	position: relative;
`;

export const NotificationItemIcon = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
`;

export const NotificationItemContent = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const NotificationItemTitle = styled.h3`
	font-size: 16px;
	font-weight: 600;
	color: #111827;
	margin: 0;
`;

export const NotificationItemDescription = styled.p`
	font-size: 14px;
	color: #6B7280;
	margin: 0;
`;

export const NotificationItemPartner = styled.p`
	font-size: 14px;
	color: #6B7280;
	margin: 0;
`;

export const NotificationItemActions = styled.div`
	display: flex;
	gap: 8px;
	margin-top: 8px;
`;

export const NotificationItemActionButton = styled.button<{ actionType?: string }>`
	background-color: #FFFFFF;
	color: #6B7280;
	border: 1px solid #D1D5DB;
	padding: 4px 8px;
	border-radius: 4px;
	font-size: 12px;
	cursor: pointer;
	
	&:hover {
		background-color: #F9FAFB;
	}
	
	${props => props.actionType === 'mark-read' && `
		color: #17B26A;
		border-color: #17B26A;
		
		&:hover {
			background-color: #F0FDF4;
		}
	`}
`;

export const NotificationItemBadge = styled.span`
	padding: 2px 8px;
	border-radius: 12px;
	font-size: 12px;
	font-weight: 500;
`;

export const NotificationItemRight = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 8px;
	min-width: 120px;
`;

export const NotificationItemTime = styled.span`
	font-size: 12px;
	color: #6B7280;
`;

export const NotificationItemDetailLink = styled.a`
	font-size: 14px;
	color: #035D9D;
	text-decoration: none;
	cursor: pointer;
	
`;

export const NotificationPagination = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 16px 0;
`;